import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { AgendaMasivaModel } from 'src/app/models/agendaMasiva.model';
import { GlobalService } from 'src/app/shared/global.service';
import { AppSettings } from 'src/app/app.settings';
import { UploadService } from 'src/app/shared/upload.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ConfirmationModalOptions } from 'src/app/shared/models/modal.model';
import { UrlService } from 'src/app/shared/services/url.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { UtilService } from 'src/app/shared/services/util.service';
declare var $: any;

@Component({
  selector: 'app-tabla-registro-excel',
  templateUrl: './tabla-registro-excel.component.html',
  styleUrls: ['./tabla-registro-excel.component.scss']
})
export class TablaRegistroExcelComponent implements OnInit, OnChanges {

  @Input() datosRegistro: AgendaMasivaModel[];
  botonCargueArchivo: boolean;
  datosCheck: AgendaMasivaModel[];
  existeError: boolean;
  modalOptions: ConfirmationModalOptions;
  verRegistro = true;

  constructor(
    private uploadService: UploadService, private spinner: NgxSpinnerService,
    private alertService: AlertService) {
    this.botonCargueArchivo = false;
    this.datosCheck = [];

    this.modalOptions =
      new ConfirmationModalOptions('Confirmación', '¿Está seguro de crear agenda?',
        'SI', 'NO', '', true, false, 'Registrar visita', null, 'btn-secondary');
  }

  ngOnInit() {
    this.existeError = this.datosRegistro && this.datosRegistro.find(dato => dato.errores.length > 0) ? true : false;
    this.modalOptions.disabled = !this.botonCargueArchivo || this.datosRegistro.length === 0 || this.existeError;
  }

  ngOnChanges(changes: import('@angular/core').SimpleChanges): void {
    this.datosCheck = [];
    this.habilitarRegistro();
  }

  habilitarRegistro() {
    if (this.datosRegistro.length > 0) {
      this.botonCargueArchivo = true;
    } else {
      this.botonCargueArchivo = false;
    }
    this.existeError = this.datosRegistro && this.datosRegistro.find(dato => dato.errores.length > 0) ? true : false;
    const noSeleccion: boolean = !this.datosRegistro || this.datosRegistro.filter(dato => dato.checked).length === 0 ? true : false;
    this.modalOptions.disabled = !this.botonCargueArchivo || this.existeError || noSeleccion;
  }

  getConfirmationModalResponse(event) {
    if (event[0]) {
      this.registrarVisitaMasiva();
    }
  }

  seleccionarFila(index: number) {
    this.datosRegistro[index].checked = !this.datosRegistro[index].checked;
    this.habilitarRegistro();
  }

  seleccionarTodo(estado) {
    this.datosRegistro.forEach(reg => {
      reg.checked = estado;
    });
    this.habilitarRegistro();
  }

  registrarVisitaMasiva(): void {
    let listaEnvio: AgendaMasivaModel[] = [];
    listaEnvio = this.datosRegistro.filter(reg => reg.checked);
    this.validarSeleccionFilas(listaEnvio, this.datosRegistro.length);
  }

  validarSeleccionFilas(lista: AgendaMasivaModel[], registrosTotales) {
    if (lista.length > 0) {
      this.spinner.show();
      this.uploadService.registrarAgendaMasiva(`/servicios/gestorDocumental/guardarAgendasMasivas`, lista)
        .subscribe(data => {
          this.spinner.hide();
          this.eliminarRegistrosAgenda(lista);
          this.alertService.generateAlertSuccess(
            `Se crearon ${lista.length} agendas exitosamente de ${registrosTotales} registros incluidos en el archivo. `
            + `Recuerde que para subir masivamente agendas de visitantes debe tener como mínimo 2 registros, `
            + `de lo contrario debe utilizar la funcionalidad de agenda individual.`, ' ');
          this.alertService.generateAlertSuccess('El cupo para el parqueadero este sujeto a verificación. ', ' ');
        }, error => {
          this.spinner.hide();
          return this.alertService.generateAlertError(error.error.message, ' ');
        });
    } else {
      this.alertService.generateAlertError('Debe seleccionar al menos una fila para registrar', ' ');
    }
  }

  eliminarRegistrosAgenda(agenda: AgendaMasivaModel[]) {
    agenda.forEach(a => {
      const index: number = this.datosRegistro.indexOf(a);
      if (index !== -1) {
        this.datosRegistro.splice(index, 1);
      }
    });
  }

  obtenerSombreado(errores) {
    return errores.length > 0 ? 'sombreado-tabla' : '';
  }

  mostrarErrores() {
    $('#importarArchivo').focus();
  }


}
